import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
function TcclTopup() {
    const [loading, setLoading] = useState(true);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [walletCode, setWalletCode] = useState([]);

    const [tcclTopup, setTopupCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ date: "", toDate: "" })
    const initialFormData = {date: "", toDate: "" }
    const handleClear = () => { setFormData(initialFormData); };
    const [addTcclTopup, SetTcclTopup] = useState({
        tcclid: "",
        topupamount:"",
        remarks: "",
        // Default value for the select dropdown
    });
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        allCustomer.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = tcclTopup.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(tcclTopup.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
     function handleSubmit(e) {
            setIsButtonDisabled(true);
            e.preventDefault();
            console.log("Form Data:", formData); a();
            async function a() {
                try {
                    const response = await axios.post('https://node.cabletvpay.in/TopupCustomerSpecific', { user, formData });
                    if (response.status === 200) {
                        console.log(response.data.result);
                        setTopupCode(response.data.result);
                        setIsButtonDisabled(false);
                    }
                } catch (err) {
                    toast.error(err.response?.data?.message || "Error fetching data");
                    setIsButtonDisabled(false)
                }
            }
        }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        SetTcclTopup(prevState => ({
            ...prevState,
            [name]: value, // Dynamically updates the correct field
        }));
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const areFieldsFilled = Object.values(addTcclTopup).every(field => field && field.trim() !== "");
        if (!areFieldsFilled) {
            toast.error("All fields are required. Please fill out the form.");
            return;
        }
        console.log("Submitting Data:", addTcclTopup);
        try {
            const response = await axios.post('https://node.cabletvpay.in/AddTcclSpecific', {
                tcclid: addTcclTopup.tcclid,

                topupamount: addTcclTopup.topupamount,
                remarks: addTcclTopup.remarks,
                user,
            });

            if (response.status === 200) {
                toast.success("Tccl Topup Details successfully added.");
                console.log("Response Data:", response.data);
                SetTcclTopup({
                    tcclid: "",
                    topupamount:"",
                    remarks: "",

                });
                fetchUserData();
            }
        } catch (err) {
            console.error(err.response?.data || err.message);
            toast.error(err.response?.data?.message || "Error adding staff.");
        }
    };
    const handleDelete = async (dumb_id) => {
        console.log(`Deleting group with ID: ${dumb_id}`); 
        try {
            const response = await axios.post(`https://node.cabletvpay.in/tcclTopupDelete`, { user, dumb_id });
            if (response.status === 200) {
                toast.success("Tccl Topup Details deleted successfully.");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error deleting staff");
        }
    };

    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/tcclTopupGetInfo', { user });
            if (response.status === 200) {
                setTopupCode(response.data.TopupDetails);

            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);

    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
            <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">TCCL TOPUP DETAILS</div>
                     <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                </div>
                <hr />
                <div className="card mt-3 mb-2 p-2">
                    <div className="card-header mb-1 text-center py-1">
                        <h5>Add Tccl Topup Details</h5>
                    </div>
                    <div className="border-1 px-1">
                        <form onSubmit={handleFormSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">


                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="tcclid" className="text-center valuesDec text-navy">Enter ID</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="tcclid" id="tcclid" onChange={handleInputChange} value={addTcclTopup.tcclid} placeholder="Enter ID.." />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="topupamount" className="text-center valuesDec text-navy">Enter Topup Amount</label>
                                        <input type="text" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="topupamount" id="topupamount" onChange={handleInputChange} value={addTcclTopup.topupamount} placeholder="Topup Amount" />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="remarks" className="text-center valuesDec text-navy">Remarks</label>
                                        <input type="textarea" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="remarks" id="remarks" onChange={handleInputChange} value={addTcclTopup.remarks} placeholder="Remarks..." />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6 col-12">
                                    <div className="d-flex justify-content-end ">
                                        <input type="submit" className="btn btn-info bg-info filterBtn rounded text-light h-100 pb-4 pb-lg-1 " value="Add Tccl Topup" />
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
                <div className="mt-1 mb-2">
                    <div className="border-0 px-1">

                        <form onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">

                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">From</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 mt-lg-2 pt-2">
                                    <input type="submit" className="btn btn-info bg-info filterBtn rounded text-light h-75 pb-3 pb-lg-1 w-100" value="Filter" />
                                </div>
                                <div className="col-lg-1 col-md-3 col-6  py-4  pt-lg-4 mt-lg-2 pt-2 d-flex justify-content-center">
                                    <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button
                                                        onClick={downloadCSV}
                                                        className="btn btn-dark border-right px-lg-3 px-5"
                                                    >
                                                        <i className="fas fa-download" /> Download
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th>Sl_No</th>

                                    <th>Date</th>

                                    <th>Remarks</th>
                                    <th>ID</th>
                                    <th>Tccl Amount</th>

                                    <th>Delete</th>



                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.Pay === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                            <td>{row.id}</td>
                                            <td>{row.date}</td>
                                            <td>{row.remarks}</td>
                                            <td>{row.tccl_id}</td>
                                            <td>{row.tccl_topup_amount}</td>  
                                            <td className='text-center'><button className='btn btn-danger' onClick={() => handleDelete(row.dumb_id)}><i className="fas fa-trash" /></button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer filterBtn">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
             
            </div>
        </div>
    );
}

export default TcclTopup;
